/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { OneExperimentsProvider } from '@americanexpress/one-experiments';
import { isOneXpEnabled } from '../utils';

const OneXp = ({ locale, pathname, children }) => {
  if (isOneXpEnabled({ locale, pathname })) {
    return <OneExperimentsProvider>{children}</OneExperimentsProvider>;
  }
  return children;
};

OneXp.propTypes = {
  locale: PropTypes.string,
  pathname: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default OneXp;
